export default "__VITE_ASSET__BXD4WYgO__"